export default __webpack_public_path__ + "static/media/earth.081bcc3d.glb";